import React from 'react';

interface GameMessageProps {
  message?: string;
}

export const GameMessage: React.FC<GameMessageProps> = ({ message }) => {
  if (!message) return null;
  return (
    <div className="game-message">
      {message}
    </div>
  );
};
